import React, { useEffect, useState } from 'react'
import {
  CNav,
  CNavItem,
  CNavLink,
  CContainer,
  CRow,
  CCol,
  CCard,
  CTable,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CSpinner,
} from '@coreui/react'

import PatientAppointmentDetails from '../../services/general/appointmentData.api'

const PatientInfoDisplay = ({ diagnosis, formData }) => {
  // Get today's date
  const currentDate = new Date().toLocaleDateString('en-US')
  let [providerName, setProviderName] = useState(null)

  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role

  const normalizeFacilityType = (value) => String(value || '').trim().toLowerCase()

  const getFacilityType = (patient = {}) =>
    normalizeFacilityType(
      patient.FacilityType ||
      patient.facilityType ||
      patient.Type ||
      patient.type ||
      formData.FacilityType ||
      formData.facilityType ||
      formData.Type ||
      formData.type ||
      '',
    )

  const getPatientType = (patient = {}) => {
    if (getFacilityType(patient) !== 'snf') return 'N/A'

    return patient.PatientType || patient.patientType || formData.PatientType || formData.patientType || 'N/A'
  }

  const getAppointmentData = async () => {
    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)
      flatAppointments = flatAppointments.filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')

      return flatAppointments
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      let appointments = await getAppointmentData()
      let providerDetails = appointments?.filter((ID) => ID.current.Patient.value === formData.PatientID)
      if (providerDetails && providerDetails.length > 0) {
        setProviderName(providerDetails[0].current.Provider.label)
      }
    }

    fetchData()
  }, [])

  return (
  <CCard
                    className="p-2"
                    style={{
                      borderRadius: '1rem',
                      background: role === 'provider' ? '#191919' : '',
                      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                      overflow: 'hidden',
                    }}
                  >
                    <CTable>
      {diagnosis.map((patient) => (
        <CTableBody>
         <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Facility Name:</strong>
            </CTableHeaderCell>
          
         <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>
            {patient.FacilityName}
           </CTableDataCell>
               </CTableRow>

           <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Patient Type:</strong>
            </CTableHeaderCell>

         <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>
            {getPatientType(patient)}
           </CTableDataCell>
               </CTableRow>

           <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Room:</strong>
            </CTableHeaderCell>
            <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>{patient.Room} </CTableDataCell>
               </CTableRow>       
         
           <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Provider Name:</strong></CTableHeaderCell>
           <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>{providerName || 'N/A'}</CTableDataCell>
           </CTableRow>

            {/* {!providerName && <CButton color="primary" className="ms-auto" style={{ fontSize: '0.9rem' }}>Schedule Appointment</CButton>} */}
       
           <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Created Date:</strong></CTableHeaderCell>
           <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>{new Date(currentDate).toLocaleDateString('en-US')}</CTableDataCell>
          </CTableRow>
           <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Last Visit Date:</strong></CTableHeaderCell>
           <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}> {currentDate}
          </CTableDataCell>
          </CTableRow>
           <CTableRow>
                <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
            <strong style={{ fontSize: '1rem' }}>Last Updated Date:</strong>
            </CTableHeaderCell>
          
         <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>
                 {currentDate || 'N/A'}
               </CTableDataCell>
               </CTableRow>
        </CTableBody>
      ))}
   </CTable>
   </CCard>
  )
}

export default PatientInfoDisplay
